import $ from 'jquery';
import getDeviceTypeFromHeaders from '../../utils/DeviceTypeUtil';

module.exports = (paramApp) => {
  const App = paramApp;

  // Render the version of the credit gateway page when there is an AS2 message
  // We want to do this when the inline summary API call fails
  // In order to render this page, we import mock data to mimic a card in the
  // user's profile, along with a message of type AS2 in the notifications field
  App.channel.on('render:as2:credit:gateway:page', async () => {
    const as2MockData = await import(/* webpackChunkName: "as2-mock-data" */ '@feature/credit-gateway/src/static/as2MockData.json');
    const RenderPageComponent = (await import(/* webpackChunkName: "credit-render-page" */ `@feature/credit-gateway/src/${process.env.ENTRY_POINT}/RenderPageComponent.js`)).default;
    const renderPageComponent = new RenderPageComponent(as2MockData.creditRespGatewayVB);

    const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
    const scrollOptions = {
      top: 0,
      left: 0,
      behavior: 'smooth',
    };
    if (isSmoothScrollSupported) {
      window.scrollTo(scrollOptions);
    } else {
      window.scrollTo(scrollOptions.top, scrollOptions.left);
    }

    renderPageComponent.renderSignedInUserWithCardsPage();
    App.channel.trigger('as2:rendered');
  });

  // Render an AS2 message on the my-account-home-bcom page
  // Same reasons as above event
  // If inline summary API fails, we want to render AS2 experience
  App.channel.on('render:my-account:as2', (view) => {
    if (view) {
      const currentContent = view.model.get('content');
      const newContent = Object.assign({}, currentContent, {
        notifications: [
          {
            type: 'AS2',
          },
        ],
      });
      view.model.set('content', newContent);
    }
  });

  App.channel.on('dismiss:credit:message', (params) => {
    let { apiUrl } = params;

    const {
      xApi,
      messageCode,
      pgName,
    } = params;

    const dismissData = {
      msgCode: messageCode,
    };
    const dismissHeaders = {};

    if (xApi) {
      apiUrl += `?_deviceType=${getDeviceTypeFromHeaders()}`;
      dismissData.pgName = pgName;
      dismissHeaders['X-Macys-ClientId'] = 'account-ui';
    }
    $.ajax({
      url: apiUrl,
      type: 'POST',
      data: dismissData,
      headers: dismissHeaders,
      success(data) { // eslint-disable-line no-unused-vars
        console.log('Message was dismissed successfully'); // eslint-disable-line no-console
      },
      error(error) { // eslint-disable-line no-unused-vars
        console.error('There was an error dismissing message: ', error); // eslint-disable-line no-console
      },
    });
  });
};
